import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import {
  getInitialLocale,
  setI18nLocale,
  supportedLocales,
  type SupportedLocale,
} from '@/i18n'

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<SupportedLocale>(getInitialLocale())
  const localeOptions = computed(() => supportedLocales)
  const currentLocale = computed(() =>
    supportedLocales.find((option) => option.code === locale.value) || supportedLocales[0]
  )

  const setLocale = (nextLocale: SupportedLocale) => {
    locale.value = nextLocale
    setI18nLocale(nextLocale)
  }

  setI18nLocale(locale.value)

  return {
    locale,
    localeOptions,
    currentLocale,
    setLocale,
  }
})
